import gql from 'graphql-tag';
import { WAREHOUSE_DELIVERY_FRAGMENT } from 'data/fragments/warehouseDelivery';

export const GET_WAREHOUSE_DELIVERIES = gql`
    query GET_WAREHOUSE_DELIVERIES($searchDate: String) {
        warehouseDeliveries(searchDate: $searchDate) {
            ...WarehouseDeliveryFragment
        }
    }
    ${WAREHOUSE_DELIVERY_FRAGMENT}
`;

export const GET_WAREHOUSE_DELIVERY = gql`
    query GET_WAREHOUSE_DELIVERY($warehouseDeliveryId: String!) {
        warehouseDelivery(warehouseDeliveryId: $warehouseDeliveryId) {
            ...WarehouseDeliveryFragment
        }
    }
    ${WAREHOUSE_DELIVERY_FRAGMENT}
`;
